import { useMemo } from 'react';

import { useStoreContext } from 'features/store';

import { useCartContext } from 'state/cart';

export const useIsStoreUnavailable = () => {
  const { isSelectingStore, isStoreAvailable, isFetchingStore } = useStoreContext();
  const { unavailableCartEntries } = useCartContext();

  const isLoadingFinished = !isSelectingStore && !isFetchingStore;

  return useMemo(() => {
    if (!isLoadingFinished) {
      return false;
    }

    const hasUnavailableItems = unavailableCartEntries?.length > 0;

    return !hasUnavailableItems && !isStoreAvailable;
  }, [isStoreAvailable, isLoadingFinished, unavailableCartEntries?.length]);
};
